import { supabase } from './supabaseClient';

const APP_DOMAIN = 'txcoordinatorpro.com';

// Reads the current hostname and returns the brokerage slug it implies, or
// null when there isn't one to resolve (apex domain, localhost, a Cloudflare
// Pages preview URL, etc.) -- those cases fall back to generic branding
// rather than erroring.
export function resolveBrokerageSlug() {
  const host = window.location.hostname;
  if (host === APP_DOMAIN || host === 'www.' + APP_DOMAIN) return null;
  if (host.endsWith('.' + APP_DOMAIN)) {
    return host.slice(0, -(APP_DOMAIN.length + 1));
  }
  return null; // localhost, *.pages.dev previews, or any other host
}

// Public, unauthenticated lookup -- relies on the "anyone reads brokerage
// branding" RLS policy (migration 0004). Only ever reads name/slug/logo/
// color; nothing sensitive lives on this table.
export async function fetchBrokerageBySlug(slug) {
  if (!slug) return null;
  const { data, error } = await supabase
    .from('brokerages')
    .select('id, name, slug, logo_url, primary_color')
    .eq('slug', slug)
    .maybeSingle();
  if (error) { console.warn('Could not resolve brokerage for slug', slug, error.message); return null; }
  if (!data) return null;
  return { id: data.id, name: data.name, slug: data.slug, logoUrl: data.logo_url, primaryColor: data.primary_color };
}
